import react, { Component } from "react";
import { Button, Modal, Breadcrumb } from "react-bootstrap";
import { connect } from "react-redux";
import Select from "react-select";
import Spinner from "react-bootstrap/Spinner";
import DatePicker from "react-date-picker";
import FloatingButton from "../../Material/FloatingButton";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import * as moment from "moment";
import { apiFetch } from "../../../apiFetch";

class DelegationEdit extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.state = {
      ModeofInput: "Referenceno",
      SectionlistArray: [],
      StaffDetailslistArray: [],
      PendingGGPapproverList: [],
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
      delegatedid: "",
      delegatedname: "",
      delegatedreferid: "",
      delegatedrefername: "",
      Inspectedby: "",
      Inspectedbyname: "",
      Inspectedbydisplay: "",
      delegateddisplay: "",
      delegatedreferdisplay: "",
      popupdelegationSection: "",
      popupdelegationreferSection: "",
      popupSection: "",
      updatemode: "",
      updatedelegationuniqueid: "",
      delagationpopup: false,
      stafflistArraySpin: "none",
      chnagebuttonstatus: "disable",
      fromdate: new Date(),
      todate: new Date(),
    };
  }

  componentDidMount = () => {
    let encryptedId = this.props.location.search;
    var CryptoJS = require("crypto-js");
    var bytes = CryptoJS.AES.decrypt(
      encryptedId.replace("?p=", ""),
      process.env.REACT_APP_ENCRYPT_PASSWORD
    );
    var decryptedId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    console.log("??..  " + decryptedId);

    let postData = { DelegationId: decryptedId };

    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL +
        "/api/AccessPrivilege/GetDelegatedApprovers",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        console.log(JSON.stringify(postData));

        console.log(data);
        if (data) {
          this.setState({});
          this.setState({
            Inspectedby: data.DelegatedApproverList[0].Originalapproverid,
            Inspectedbyname: data.DelegatedApproverList[0].Originalapprovername,
            fromdate: data.DelegatedApproverList[0].Fromdate,
            todate: data.DelegatedApproverList[0].Todate,
            updatedelegationuniqueid:
              data.DelegatedApproverList[0].DelegationId,
            updatemode: data.DelegatedApproverList[0].TypeofMode,
          });
          this.setState({
            Inspectedbydisplay:
              this.state.Inspectedby + "-" + this.state.Inspectedbyname,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });

    this.props.dispatch({ type: "headerTitle", value: "Delegation" });
    this.GetSectionListData();
    this.listofpendingapprover();
  };

  listofpendingapprover = () => {
    let postData = {
      Userid: this.props.UserId,
      UserType: this.props.userType,
      Approverid: this.state.Inspectedby,
    };
    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL +
        "/api/AccessPrivilege/GetPendingGGPList",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        if (data) {
          this.setState({ PendingGGPapproverList: data.PendingGGPList });
          if (this.state.PendingGGPapproverList.length > 0) {
            this.setState({ chnagebuttonstatus: "" });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  handlechange = (e) => {
    switch (e.target.name) {
      case "popupdelegationEmployeeId":
        this.setState({ popupdelegationEmployeeId: e.target.value });
        break;
      case "popupdelegationEmployeeName":
        this.setState({ popupdelegationEmployeeName: e.target.value });
        break;

      default:
        break;
    }
  };

  GetSectionListData = (val) => {
    let postData = { Mode: "Section" };
    apiFetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/GetGGPMaster", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.props.getToken,
      },
      body: JSON.stringify(postData),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        if (data) {
          this.setState({ SectionlistArray: data.MasterList });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.searchdelegationEmployee();
    }
  };

  fromdatechange = (date) => {
    this.setState({ fromdate: date });
  };

  todatechange = (date) => {
    this.setState({ todate: date });
  };

  handledelegationSelectFormFields = (selectedOption) => {
    this.setState({ popupdelegationSection: selectedOption.value });
  };

  approveredit = () => {
    if (this.validator.allValid()) {
      if (this.state.Inspectedby === this.state.delegatedid) {
        this.setState({
          delegatedid: "",
          delegatedname: "",
          delegateddisplay: "",
        });
        toast.error("Approver by and delegated by can't be same person", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      } else {
        let postData = {
          TypeofMode: this.state.updatemode,
          Originalapproverid: this.state.Inspectedby,
          Originalapprovername: this.state.Inspectedbyname,
          Delegatetoempid: this.state.delegatedid,
          Delegatetoname: this.state.delegatedname,
          Fromdate: this.state.fromdate,
          Todate: this.state.todate,
          Createdby: this.props.UserId,
          Createdbyname: this.props.userName,
          Mode: "Update",
          DelegationId: this.state.updatedelegationuniqueid,
        };

        apiFetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            "/api/AccessPrivilege/InsertUpdateDelegatedApprovers",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
            }
          })
          .then((data) => {
            console.log(JSON.stringify(postData));
            if (data) {
              console.log("man succes" + data.Status);
              if (data.Status === "Success") {
                this.GetListData();
                this.setState({
                  delegatedid: "",
                  delegatedname: "",
                  delegateddisplay: "",
                });
                toast.success("Updated successfully.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
                this.validator.hideMessages();
                this.props.history.push({ pathname: "/Delegation/list" });
              } else {
                this.setState({
                  delegatedid: "",
                  delegatedname: "",
                  delegateddisplay: "",
                });
                toast.error(data.Message, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
                this.validator.hideMessages();
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.props.history.push({ pathname: "/somethingwrong" });
          });
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  searchdelegationEmployee = () => {
    // alert('a')
    this.setState({ stafflistArraySpin: "", StaffDetailslistArray: [] });
    let postData = {
      EmployeeId: this.state.popupdelegationEmployeeId,
      Name: this.state.popupdelegationEmployeeName,
      Section: this.state.popupdelegationSection,
    };
    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/GetStaffDetails",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        //console.log(data)
        if (data) {
          this.setState({
            StaffDetailslistArray: data.StaffDetails,
            stafflistArraySpin: "none",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  //delegation
  searchdelegationEmployeeClear = () => {
    this.setState({
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
      popupdelegationSection: "",
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  getdelegationshow = () => {
    this.setState({
      delagationpopup: true,
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
      stafflistArraySpin: "none",
    });
  };

  getdelegationhide = () => {
    this.setState({
      delagationpopup: false,
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
    });
  };

  getdelegationDetails = (id, name) => {
    this.setState({
      delegatedid: id,
      delegatedname: name,
      delegateddisplay: id + " - " + name,
      delagationpopup: false,
    });
    this.setState({
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
      popupdelegationSection: "",
      StaffDetailslistArray: [],
    });
  };

  render() {
    let sectionOptionList = [];
    if (this.state.SectionlistArray) {
      this.state.SectionlistArray.map((data) => {
        let sData = { id: "popupSection", label: data.Code, value: data.Code };
        sectionOptionList.push(sData);
        return null;
      });
    }

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item
            href={process.env.REACT_APP_ENV + "/Delegation/list"}>
            Delegation
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Edit</Breadcrumb.Item>
        </Breadcrumb>

        <div className="content-area shadow p-3 mb-5 bg-white rounded">
          <h2 className="fs-title mb-2 mb-sm-4">Delegation</h2>

          {(() => {
            return (
              <>
                <div className="form-group row mb-2">
                  <label
                    for="auth-name"
                    className="col-sm-2 col-form-label text-muted">
                    Original Approver
                  </label>

                  <div className="col-sm-3">
                    <div className="form-group">
                      <div className="input-group mb-2">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=""
                          readOnly={true}
                          value={this.state.Inspectedbydisplay}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-2">
                  <div className="col-sm-2"> </div>
                  <div className="col-sm-5">
                    {this.validator.message(
                      "Approver",
                      this.state.Inspectedbydisplay,
                      "required"
                    )}
                  </div>
                </div>

                <div className="form-group row mb-2">
                  <label
                    for="auth-name"
                    className="col-sm-2 col-form-label text-muted">
                    Delegate To
                  </label>

                  <div className="col-sm-3">
                    <div className="form-group">
                      <div className="input-group mb-2">
                        <input
                          type="text"
                          className="form-control"
                          id=""
                          placeholder=""
                          readOnly={true}
                          value={this.state.delegateddisplay}
                          onClick={this.getdelegationshow}
                        />
                        <div className="input-group-prepend">
                          <div className="input-group-text">
                            <i
                              className="fa fa-search text-muted"
                              onClick={this.getdelegationshow}>
                              {" "}
                            </i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-2">
                  <div className="col-sm-2"> </div>
                  <div className="col-sm-5">
                    {this.validator.message(
                      "Delegate To",
                      this.state.delegateddisplay,
                      "required"
                    )}
                  </div>
                </div>

                <div className="form-group row">
                  <label for="" className="col-sm-2 col-form-label text-muted">
                    {" "}
                    From Date
                  </label>
                  <div className="col-sm-4">
                    <div className="input-group mb-2 mr-sm-2">
                      <DatePicker
                        format="dd-MM-y"
                        onChange={this.fromdatechange}
                        minDate={new Date(this.state.fromdate)}
                        className="date-picker-style form-control"
                        value={new Date(this.state.fromdate)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-2">
                  <div className="col-sm-2"> </div>
                  <div className="col-sm-5">
                    {this.validator.message(
                      "From Date",
                      this.state.fromdate,
                      "required"
                    )}
                  </div>
                </div>

                <div className="form-group row">
                  <label for="" className="col-sm-2 col-form-label text-muted">
                    {" "}
                    To Date
                  </label>
                  <div className="col-sm-4">
                    <div className="input-group mb-2 mr-sm-2">
                      <DatePicker
                        format="dd-MM-y"
                        onChange={this.todatechange}
                        minDate={new Date(this.state.fromdate)}
                        className="date-picker-style form-control"
                        value={new Date(this.state.todate)}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12">
                    {" "}
                    <hr></hr>
                    <div className="col-lg-12 text-right">
                      <button
                        type="button"
                        className="btn btn-primary-01 px-5"
                        disabled={
                          this.state.chnagebuttonstatus === "disable"
                            ? true
                            : false
                        }
                        className={`${
                          this.state.chnagebuttonstatus === "disable"
                            ? "btn btn-secondary"
                            : "btn btn-primary-01"
                        }`}
                        onClick={this.approveredit}>
                        {" "}
                        Change
                      </button>
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-2">
                  <div className="col-sm-2"> </div>
                  <div className="col-sm-5">
                    {this.validator.message(
                      "To Date",
                      this.state.todate,
                      "required"
                    )}
                  </div>
                </div>

                <div className="table-responsive ">
                  <table className="table table-hover">
                    <thead className="thead-lightBlue">
                      <tr>
                        <th scope="col"> Referenceno </th>
                        <th scope="col"> Submitted Date </th>
                        <th scope="col"> Original Approver </th>
                        <th scope="col"> Delegated to </th>
                        <th scope="col"> From Date </th>
                        <th scope="col"> To Date</th>
                      </tr>
                    </thead>
                    {(() => {
                      if (this.state.PendingGGPapproverList.length > 0) {
                        return (
                          <>
                            <tbody>
                              {this.state.PendingGGPapproverList.map(
                                (value, index) => (
                                  <tr>
                                    <td> {value.Referenceno} </td>
                                    <td>
                                      {value.Submitteddate
                                        ? moment(value.Submitteddate).format(
                                            "DD-MM-yyyy HH:mm:ss"
                                          )
                                        : ""}
                                    </td>
                                    <td>
                                      {" "}
                                      {value.Oriapproverid} -{" "}
                                      {value.Oriapprovername}{" "}
                                    </td>
                                    <td>
                                      {" "}
                                      {value.Delegatetoempid} -{" "}
                                      {value.Delegatetoname}{" "}
                                    </td>
                                    <td> {value.Fromdate} </td>
                                    <td> {value.Todate} </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </>
                        );
                      }
                    })()}
                  </table>
                  {(() => {
                    if (this.state.PendingGGPapproverList.length <= 0) {
                      return (
                        <p className="text-center">Sorry there is no data</p>
                      );
                    }
                  })()}
                </div>
              </>
            );
          })()}
        </div>

        <Modal show={this.state.delagationpopup} size="lg">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      Autocomplete="off"
                      className="form-control"
                      name="popupdelegationEmployeeId"
                      value={this.state.popupdelegationEmployeeId}
                      onChange={this.handlechange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      Autocomplete="off"
                      className="form-control"
                      name="popupdelegationEmployeeName"
                      value={this.state.popupdelegationEmployeeName}
                      onChange={this.handlechange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      options={sectionOptionList}
                      onChange={this.handledelegationSelectFormFields}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.searchdelegationEmployeeClear()}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.searchdelegationEmployee}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>
            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.StaffDetailslistArray.map((staff, index) => (
                      <tr
                        onClick={() =>
                          this.getdelegationDetails(
                            staff.EmployeeId,
                            staff.Name
                          )
                        }
                        className="cursor-pointer">
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.EmployeeId} </td>
                        <td> {staff.Name} </td>
                        <td> ({staff.Account}) </td>
                        <td> {staff.Email} </td>
                        <td> {staff.Section} </td>
                        <td> {staff.SectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.StaffDetailslistArray.length <= 0 &&
                    this.state.stafflistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
                <p className="text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{ display: this.state.stafflistArraySpin }}
                    className="text-center"
                  />
                </p>
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.getdelegationhide()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <FloatingButton />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(DelegationEdit);
